export default "<p>sendnotifications works!</p>\n"